import React, { useState } from "react";
import LoginComponent from "./LoginComponent";
import { Box, Button, Typography } from "@mui/material";

function LoginContainer() {

  return (
    <div className="container">
        <LoginComponent />
    </div>
  );
}

export default LoginContainer;
